export const worksData = [
  {
    id: 1,
    shortTitle: "Телеканал СТС",
    title: "Диджитал-дизайнер",
    description: "Создание креативов с видео внутри баннера, анимация баннеров в adobe animate, создание покадровых гифок",
    thumbnail: "./portfolio/logos/ctc.png",
    link1: "./portfolio/html5/interactive/dbv/js/index.html",
    link2: "./portfolio/html5/interactive/dyldy/index.html",
    link3: "./portfolio/html5/interactive/fortboyard/index.html",
    link4: "./portfolio/gif/ads/fb/fb_300x250.gif",
    link5: "./portfolio/gif/ads/fb/fb_2_300x250.gif",
    link6: "./portfolio/gif/ads/psy/PSY_300x250.gif",
    link7: "./portfolio/gif/ads/sf/SF_300x250.gif",
    link8: "./portfolio/gif/ads/psy/PSY_990x200.gif",
    link9: "./portfolio/gif/ads/sf/SF_990x200.gif",
    link10: "./portfolio/gif/stickers/alfa.gif",
    link11: "./portfolio/gif/stickers/boy.gif",
    link12: "./portfolio/gif/stickers/candy.gif",
    link13: "./portfolio/gif/stickers/grandma.gif",
    category: "Веб-дизайн",
    year: "2018-2019",
    type: "Веб-дизайн",
    technologies: ["HTML, CSS, JS, Photoshop, Animate, After Effects, Media Encoder, Google Web Designer"],
    details: "Проект включал разработку полного стека приложения с авторизацией пользователей.",
    popupComponent: "Project1Popup"
  },
  {
    id: 2,
    shortTitle: "ТД ЦУМ",
    title: "Технический дизайнер",
    description: "Огромное количество ресайзов рекламных акций в статике, гиф, и HTML5, Playable Ads, Видеомонтаж и Моушн дизайн",
    thumbnail: "./portfolio/logos/tsum.png",
    link1: "./portfolio/html5/main/tsum/240x400/index.html",
    link2: "./portfolio/playable/tsum/index.html",
    link3: "./portfolio/photoshop/tsum/DSDM-135_1.jpg",
    link4: "./portfolio/photoshop/tsum/DSDM-135_2.jpg",
    link5: "./portfolio/photoshop/tsum/DSDM-135_3.jpg",
    link6: "./portfolio/photoshop/tsum/DSDM-135_4.jpg",
    link7: "./portfolio/photoshop/tsum/DSDM-135_Cover_1.jpg",
    link8: "./portfolio/photoshop/tsum/DSDM-135_Cover_2.jpg",
    link9: "./portfolio/photoshop/tsum/DSDM-135_Cover_3.jpg",
    link10: "./portfolio/photoshop/tsum/DSDM-135_Cover_4.jpg",
    link11: "./portfolio/photoshop/tsum/DSDM-157_Artboard_1.jpg",
    link12: "./portfolio/photoshop/tsum/DSDM-191_300x250_1_copy.jpg",
    link13: "./portfolio/photoshop/tsum/DSDM-191_300x250_1.jpg",
    link14: "./portfolio/photoshop/tsum/DSDM-191_300x600_1_copy.jpg",
    link15: "./portfolio/photoshop/tsum/DSDM-191_300x600_1.jpg",
    link16: "./portfolio/photoshop/tsum/DSDM-191_728x90_1_copy.jpg",
    link17: "./portfolio/photoshop/tsum/DSDM-191_728x90_1.jpg",
    category: "Веб-дизайн",
    year: "2019-2021",
    type: "Веб-дизайн",
    technologies: ["HTML, CSS, JS, Photoshop, Animate, After Effects, Media Encoder, Google Web Designer"],
    details: "Проект включал разработку полного стека приложения с авторизацией пользователей.",
    popupComponent: "Project2Popup"
  },
  {
    id: 3,
    shortTitle: "Лига Ставок",
    title: "Диджитал-дизайнер/Разработчик",
    description: "Разработка адаптивных баннеров для Sports, Okko, Championat и др., Разработка плагинов для фигмы. Разработка чат-ботов",
    thumbnail: "./portfolio/logos/ligastavok.png",
    link1: "./portfolio/html5/main/ligastavok/2025-jan-7777/100x200px_7777_sports/index.html",
    link2: "./portfolio/html5/main/ligastavok/2025-feb-8marta/100x200px_8marta_sports/index.html",
    link3: "./portfolio/html5/main/ligastavok/2025-march-7777/100x200px_7777_sports/index.html",
    link4: "./portfolio/html5/main/ligastavok/2025-may-app/100x200px_app_sports/index.html",
    link5: "./portfolio/html5/main/ligastavok/2025-may-jp/100x200px_jp_sports/index.html",
    link6: "./portfolio/html5/main/ligastavok/2025-may-app/100x200px_app_sports/index.html",
    link7: "./portfolio/html5/main/ligastavok/2025-jul-25m/100x200px_sports/index.html",
    link8: "./portfolio/html5/main/ligastavok/2025-sep-lp/100x200px_lp_sports/index.html",
    link9: "./portfolio/html5/main/ligastavok/2025-oct-mega/100x200px_jp_sports/index.html",
    link10: "./portfolio/html5/main/ligastavok/2222/100x200px/index.html",
    link11: "./portfolio/html5/main/ligastavok/",
    link12: "./portfolio/html5/main/ligastavok/",
    link13: "./portfolio/html5/main/ligastavok/",
    link14: "./portfolio/html5/main/ligastavok/",
    link15: "./portfolio/html5/main/ligastavok/",
    link16: "./portfolio/html5/main/ligastavok/",
    link17: "./portfolio/html5/main/ligastavok/",
    category: "Frontend",
    year: "2022-2025",
    type: "Frontend",
    technologies: ["HTML, CSS, JS, Photoshop, Animate, After Effects, Media Encoder, Google Web Designer, Python, TypeScript, React"],
    popupComponent: "Project3Popup"
  },
  {
    id: 4,
    shortTitle: "Bono.digital",
    title: "Bono.digital",
    description: "Разработка баннеров. Верстка сайтов. Кодинг",
    thumbnail: "./portfolio/logos/bono.png",
    link1: "./portfolio/html5/main/bono/mstiteli/index.html",
    link2: "./portfolio/html5/main/bono/nvidia/index.html",
    link3: "./portfolio/html5/main/bono/Proplan/DogChow/index.html",
    link4: "./portfolio/html5/main/bono/Proplan/Purina/index.html",
    link5: "./portfolio/html5/main/bono/Tele2/1/index.html",
    link6: "./portfolio/html5/main/bono/Tele2/2/index.html",
    link7: "./portfolio/html5/main/bono/Uniqlo/index.html",
    link8: "./portfolio/html5/main/bono/Volvo/XC60/index.html",
    category: "Frontend",
    year: "2014-2017",
    type: "Frontend",
    technologies: ["HTML, CSS, JS, Photoshop, Animate, Google Web Designer"],
    popupComponent: "Project4Popup"
  },
  {
    id: 5,
    shortTitle: "Actis Wunderman",
    title: "Actis Wunderman",
    description: "Разработка огромного количества ресайзов HTML баннеров в Adobe Animate",
    thumbnail: "./portfolio/logos/actis.png",
    link1: "./portfolio/html5/main/bono/mstiteli/index.html",
    link2: "./portfolio/html5/main/bono/nvidia/index.html",
    link3: "./portfolio/html5/main/bono/Proplan/DogChow/index.html",
    link4: "./portfolio/html5/main/bono/Proplan/Purina/index.html",
    link5: "./portfolio/html5/main/bono/Tele2/1/index.html",
    link6: "./portfolio/html5/main/bono/Tele2/2/index.html",
    link7: "./portfolio/html5/main/bono/Uniqlo/index.html",
    link8: "./portfolio/html5/main/bono/Volvo/XC60/index.html",
    category: "Веб-дизайн",
    year: "2017-2018",
    type: "react",
    technologies: ["React", "TypeScript", "Material-UI", "Chart.js"],
    popupComponent: "Project5Popup"
  },
  {
    id: 6,
    shortTitle: "Hybrid",
    title: "Hybrid",
    description: "Разработка огромного количества ресайзов HTML баннеров в Adobe Animate, Tumult Hype 4",
    thumbnail: "./portfolio/logos/hybrid.png",
    fullImage: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200&h=600&fit=crop",
    category: "Веб-дизайн",
    year: "2021-2022",
    type: "Веб-дизайн",
    technologies: ["HTML5", "CSS3", "GSAP", "Swiper.js"],
    popupComponent: "Project6Popup"
  },
  {
    id: 7,
    shortTitle: "Лендинг приложения LigaStavok",
    title: "Лендинг приложения LigaStavok",
    description: "Разработка от А до Я лендинга приложения с использованием анимационных технологий и адаптивности. Также в лендинге организован импорт коэффициентов из JSON",
    thumbnail: "./portfolio/logos/ligastavok.png",
    link1: "./portfolio/landings/app-ligastavok/index.html",
    category: "Frontend",
    year: "2025",
    type: "Лендинг",
    technologies: ["HTML5, ", "CSS3, ", "JS, ", "GSAP, ", "Canvas, ", "adaptive"],
    popupComponent: "Project7Popup"
  },
  {
    id: 8,
    shortTitle: "Плагин для Figma ABCFF4",
    title: "Плагин для Figma ABCFF4",
    description: "Разработка плагина для Figma, для автоматизации создания баннеров. Очень полезно для графических дизайнеров, когда количество баннеров на холсте превышает нормы. Плган импортирует баннеры из таблицы Google Docs, которая также является медиапланом.",
    thumbnail: "./portfolio/logos/ligastavok.png",
    link1: "./portfolio/javascript/figma-api/1.png",
    link2: "./portfolio/javascript/figma-api/2.png",
    category: "Javascript",
    year: "2025",
    type: "Javascript",
    technologies: ["HTML5, ", "CSS3, ", "JS"],
    popupComponent: "Project8Popup"
  }
];

export const workTypes = [
  { id: 'all', label: 'Все', count: worksData.length },
  { id: 'Веб-дизайн', label: 'Веб-дизайн', count: worksData.filter(w => w.type === 'Веб-дизайн').length },
  { id: 'Лендинг', label: 'Лендинг', count: worksData.filter(w => w.type === 'Лендинг').length },
  { id: 'Frontend', label: 'Frontend', count: worksData.filter(w => w.type === 'Frontend').length },
  { id: 'react', label: 'React', count: worksData.filter(w => w.type === 'react').length },
  { id: 'python', label: 'Python', count: worksData.filter(w => w.type === 'python').length },
  { id: 'Javascript', label: 'Figma API', count: worksData.filter(w => w.type === 'Javascript').length },
];